import { Redirect, Slot } from "expo-router";
import { View } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import useAuth from "@/hooks/useAuth";

export default function Layout() {
  const { colors } = useTheme();
  const { session, loading } = useAuth();

  if (!session && !loading) {
    return <Redirect href="/sign-in" />;
  }
  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.background,
      }}
    >
      <View
        style={{
          flex: 1,
          width: "100%",
          maxWidth: 800,
        }}
      >
        <Slot />
      </View>
    </View>
  );
}
